// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor_principal_per{
    display:flex;
    align-items: center; /* Centra horizontalmente */
    justify-content: center; /* Centra verticalmente */
    text-align: center;
    margin-bottom: 0px; /* Evita que la imagen se repita */
    margin-top: 0px;
}

.estadisticas_por_temas {
    font: 1.4em Gupter;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    border: double 7px white;
    background-color:#a2d1e0;
    margin-bottom: 20px;
    margin-top: 20px;
    border-radius: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
}

.estadisticas_por_examen {
    font: 1.4em Gupter;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    border: double 7px white;
    background-color:#a2d1e0;
    margin-bottom: 20px;
    margin-top: 20px;
    border-radius: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.titulo_e {
    font: 1.8em Gupter;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: white;
    background-color: #545454;
    border: double 7px white;
    border-radius: 20px;
    padding-top: 10px;
    padding-bottom: 10px;}

td.verde {
    color:rgb(68, 211, 68);
    font-weight: bold;
}

td.rojo {
    color:rgb(238, 47, 47);
    font-weight: bold;
}


th.verde {
    color:forestgreen;
    font-weight: bold;
}

th.rojo {
    color:firebrick;
    font-weight: bold;
}

td.azul {
    color:#0767c2;
}

th.azul {
    color:#072c76;
    font-weight: bold;
}

table.tabla {
    width: 100%; /* Ajusta el tamaño al 100% del contenedor padre */
    margin: auto;
    border-radius: 20px;
    border-collapse: separate; /* Esto es importante para que el borde no colapse */
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/css/Estadisticas.css"],"names":[],"mappings":"AAEA;IACI,YAAY;IACZ,mBAAmB,EAAE,2BAA2B;IAChD,uBAAuB,EAAE,yBAAyB;IAClD,kBAAkB;IAClB,kBAAkB,EAAE,kCAAkC;IACtD,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB,CAAC;;AAEzB;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;;AAGA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW,EAAE,kDAAkD;IAC/D,YAAY;IACZ,mBAAmB;IACnB,yBAAyB,EAAE,oDAAoD;IAC/E,gBAAgB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap\");\r\n\r\n.contenedor_principal_per{\r\n    display:flex;\r\n    align-items: center; /* Centra horizontalmente */\r\n    justify-content: center; /* Centra verticalmente */\r\n    text-align: center;\r\n    margin-bottom: 0px; /* Evita que la imagen se repita */\r\n    margin-top: 0px;\r\n}\r\n\r\n.estadisticas_por_temas {\r\n    font: 1.4em Gupter;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    border: double 7px white;\r\n    background-color:#a2d1e0;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n    border-radius: 20px;\r\n    padding-top: 40px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.estadisticas_por_examen {\r\n    font: 1.4em Gupter;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    border: double 7px white;\r\n    background-color:#a2d1e0;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n    border-radius: 20px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.titulo_e {\r\n    font: 1.8em Gupter;\r\n    display: flex;\r\n    text-align: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-weight: bold;\r\n    color: white;\r\n    background-color: #545454;\r\n    border: double 7px white;\r\n    border-radius: 20px;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;}\r\n\r\ntd.verde {\r\n    color:rgb(68, 211, 68);\r\n    font-weight: bold;\r\n}\r\n\r\ntd.rojo {\r\n    color:rgb(238, 47, 47);\r\n    font-weight: bold;\r\n}\r\n\r\n\r\nth.verde {\r\n    color:forestgreen;\r\n    font-weight: bold;\r\n}\r\n\r\nth.rojo {\r\n    color:firebrick;\r\n    font-weight: bold;\r\n}\r\n\r\ntd.azul {\r\n    color:#0767c2;\r\n}\r\n\r\nth.azul {\r\n    color:#072c76;\r\n    font-weight: bold;\r\n}\r\n\r\ntable.tabla {\r\n    width: 100%; /* Ajusta el tamaño al 100% del contenedor padre */\r\n    margin: auto;\r\n    border-radius: 20px;\r\n    border-collapse: separate; /* Esto es importante para que el borde no colapse */\r\n    overflow: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
